import { css } from '@emotion/css'

export const mapViewSt = css`
  width: 100%;
  height: 100%;
  min-height: inherit;
  z-index: 0;
`
